import { render } from "./NotaFiscalImpostos.vue?vue&type=template&id=2526e44e&scoped=true&ts=true"
import script from "./NotaFiscalImpostos.vue?vue&type=script&lang=ts"
export * from "./NotaFiscalImpostos.vue?vue&type=script&lang=ts"

import "./NotaFiscalImpostos.vue?vue&type=style&index=0&id=2526e44e&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2526e44e"]])

export default __exports__